import React from 'react';

interface MouseLightProps {
  mousePosition: { x: number; y: number };
}

export function MouseLight({ mousePosition }: MouseLightProps) {
  return (
    <div 
      className="pointer-events-none fixed inset-0 z-30 transition-opacity duration-300"
      style={{
        background: `radial-gradient(300px circle at ${mousePosition.x}px ${mousePosition.y}px, 
          rgba(59, 130, 246, 0.15), 
          rgba(147, 51, 234, 0.15), 
          transparent 40%)`
      }}
    />
  );
}